import { render, staticRenderFns } from "./acceptDialog.vue?vue&type=template&id=6864b867&scoped=true"
import script from "./acceptDialog.vue?vue&type=script&lang=js"
export * from "./acceptDialog.vue?vue&type=script&lang=js"
import style0 from "./acceptDialog.vue?vue&type=style&index=0&id=6864b867&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6864b867",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6864b867')) {
      api.createRecord('6864b867', component.options)
    } else {
      api.reload('6864b867', component.options)
    }
    module.hot.accept("./acceptDialog.vue?vue&type=template&id=6864b867&scoped=true", function () {
      api.rerender('6864b867', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/medicineFind/components/acceptDialog.vue"
export default component.exports